import { useShop } from "@/context/ShopContext";
import { img } from "@/lib/api";

export const Logo = ({ className = "h-10", variant = "red", testId = "site-logo" }) => {
  const { settings } = useShop();
  const custom = settings?.logo_url && !settings.logo_url.startsWith("/logo") ? img(settings.logo_url) : null;
  const src = variant === "cream" ? "/logo-cream.png" : custom || "/logo-mm2.png";
  return <img data-testid={testId} src={src} alt="Maison Madison" className={`${className} ${/\bw-/.test(className) ? "" : "w-auto"} object-contain select-none`} draggable={false} />;
};
